import styled from "styled-components";
import { rem } from "../Theme/Theme.constants.js";
import { DefaultHeadingProps, HeadingProps } from "./Heading.types.js";

const fontWeightMap: Record<NonNullable<HeadingProps["weight"]>, number> = {
    normal: 400,
    semibold: 500,
    bold: 700,
};

const fontSizeMap: Record<NonNullable<HeadingProps["size"]>, string> = {
    large: rem(3.5),
    medium: rem(2.625),
    small: rem(1.75),
};

export const StyledHeading = styled.h1<HeadingProps & DefaultHeadingProps>`
    color: ${(props) => props.color};
    font-weight: ${(props) => fontWeightMap[props.weight]};
    font-size: ${(props) => fontSizeMap[props.size]};
    line-height: normal;
    letter-spacing: 0;
    margin: 0;
    text-align: ${(props) => props.align};
    ${({ uppercase }) => uppercase && `text-transform: uppercase;`}
`;
